import { Injectable } from '@angular/core';
import { Router, CanActivate, ActivatedRouteSnapshot } from '@angular/router';
import {
  DeliveryMethodService,
  DeliveryState,
  LocationState,
  VenueManagementState,
} from '@moduurnv2/libs-orderingapp/src/core';
import { Store } from '@ngxs/store';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
@Injectable()
export class WJVerifyLoungeGuard implements CanActivate {
  constructor(
    public router: Router,
    private store: Store,
    private deliveries: DeliveryMethodService
  ) {}
  canActivate(route: ActivatedRouteSnapshot): Observable<boolean> | boolean {
    const { _id } = this.store.selectSnapshot(
      LocationState.getSelectedLocation
    );
    const selectedDelivery = this.store.selectSnapshot(
      DeliveryState.getSelectedDelivery
    );

    const venues = this.store.selectSnapshot(VenueManagementState.getVenues)
    const { queryParams } = this.router.getCurrentNavigation().finalUrl;
    let tableNumber;

    //get the table number from the query string, or failing that from the already selected table.
    if (queryParams && queryParams.tableNumber)
      tableNumber = queryParams.tableNumber;
    else {
      const venue = this.store.selectSnapshot(
        VenueManagementState.getSelectedLoungeTable
      );
      if (venue && venue.name) tableNumber = venue.name;
    }

    //check if table number is valid.
    if (Array.isArray(venues)) {
      const validTable = venues.find((venue) => venue.name && venue.name.startsWith(tableNumber))
      if (validTable == undefined) {
        this.router.navigate(['emptyTable']);
        return false;
      }
    }


    // if we already have a selected delivery type and it's lounge delivery make sure we have a defined table number or else ask them to rescan.
    if (selectedDelivery && selectedDelivery.textCode === 'DELIVERYTYPE08') {
      if (tableNumber == undefined) {
        this.router.navigate(['emptyTable']);
        return false;
      }
    }

    //hmm, we don't have a delivery type selected
    //go get the delivery types and if there's a lounge delivery, make sure the table name is set, 
    // if not send them the empty table screen.
    return this.deliveries.fetchDeliveries(_id).pipe(
      map((deliveries) => {
        const { deliveryTypes } = deliveries;
        const lounge = deliveryTypes.find(
          (delivery) => delivery.textCode == 'DELIVERYTYPE08'
        );
        if (
          (lounge && deliveryTypes.length === 1) ||
          deliveryTypes[0].textCode === 'DELIVERYTYPE08'
        ) {
          if (tableNumber == undefined) {
            this.router.navigate(['emptyTable']);
            return false;
          }
        }
        return true;
      })
    );
  }
}
